module.exports = __webpack_public_path__ + "static/gan-c23f0399fb2a358b2e9d8905b04208e7.png";